// extracted by mini-css-extract-plugin
export default {"notification-dot-container":"NotificationDot_notification-dot-container__NKu0S","notification-dot":"NotificationDot_notification-dot__TDDZw"};